import store from '@/store'
export function addLogs(str,that) {
  try {
    const logs = store.state.audio.logs
    const now = new Date()
    const year = now.getFullYear()
    const month = now.getMonth() + 1
    const day = now.getDate()
    const hours = now.getHours()
    const minutes = now.getMinutes()
    const seconds = now.getSeconds()
    const time = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    logs.push(`当前时间：${time}，日志内容：${str}`)
    const data = {
      //   uploadId: this.multipartUploadParams.UploadId,
      //   relationId: this.$store.state.audio.audioMsg.relationId,
      //   path: this.multipartUploadParams.Key,
      //   region: this.multipartUploadParams.Region,
      //   bucket: this.multipartUploadParams.Bucket,
      fileName: that.audioData ? that.audioData.title + '.mp3' : '',
      logs: JSON.stringify(logs)
    }
    localStorage.setItem('zzp-audioRecorder', JSON.stringify(data))
  } catch (err) {
    console.log(err)
  }
}
